import { SITE } from '../../../config/site';
import styles from './AnnouncementBar.module.css';

export function AnnouncementBar() {
  return (
    <div className={styles.bar}>
      <div className={`container ${styles.inner}`}>
        <span className={styles.text}>{SITE.announcement}</span>
        <a href={`tel:${SITE.phone.replace(/\D/g, '')}`} className={styles.phone}>
          <PhoneIcon />
          {SITE.phone}
        </a>
      </div>
    </div>
  );
}

function PhoneIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M6.6 10.8a15.05 15.05 0 006.6 6.6l2.2-2.2a1 1 0 011-.24 11.36 11.36 0 003.56.57 1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1 11.36 11.36 0 00.57 3.56 1 1 0 01-.24 1l-2.23 2.24z"
        fill="currentColor"
      />
    </svg>
  );
}
